export default __webpack_public_path__ + "static/media/SL_Mathematics_AA.ae5b86a0.svg";